import { Navigate } from 'react-router-dom'

const Home = () => {
  // temporary redirect to search page while poc progress
  return <Navigate replace to="/plus/search" />
}

export default Home
